export interface IWalletBallance {
  fitBalance: number
  caloBalance: number
}
export interface IWithdrawFee {
  caloAmount: string
  fitAmount: string
}

export interface ITransactionHistoryRequest {
  limit?: number
  offset?: number
  filter?: any
  sort?: any
}

export const WITHDRAW_STEPS = {
  INFO: 'INFORMATION',
  OTP: 'OTP',
}
